import CONFIG from './config';
import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';

import Header from './Header';
import { MetaDataBar, TagBar } from './Utils';
import { Post } from './Post'
import withArticleMetaData from './withArticleMetaData';
import ReactGA from 'react-ga';

class Article extends Component {
	constructor() {
		super();
		this.state = {
			isLoading: false,
			post: "",
			metadata: {image: "", tags: []}
		}
	}
	componentDidUpdate(prevProps) {
		window.scrollTo(0, 0);
		if (prevProps != this.props)
			this.requestArticle()
	}

	componentDidMount() {
		this.requestArticle();
		ReactGA.initialize('UA-141772527-1');
		ReactGA.pageview(this.props.location.pathname);
	}

	requestArticle() {
		this.setState({isLoading: true});

		const { postname } = this.props.match.params;
		var article_url;

		try {
			article_url = `/articles/${postname}/README.md`
		} catch (error) {
			window.location.href = '/'
		}

		fetch(article_url).then(r => {
			if (r.ok) {
				return r.text();
			} else {
				throw new Error('Error in requsting Article at ' + article_url);
			}
		})
		.then(data => this.setState({ post: data, isLoading: false }))
		.catch(error => this.setState({ error, isLoading: false }))

		fetch(`/articles/${postname}/meta.json`).then(r => r.json()).then(m => {
			this.setState({
				metadata: m
			})
		})

	}
	render() {
		const { post, metadata } = this.state;

		return (
			<div id="Article">
				<Header url={metadata.url} image={metadata.image} >
				</Header>

				<main className='site-body'>
					<article className='post'>
						<MetaDataBar
							author={metadata.author}
							authorimage={metadata.authorimage}
							created={metadata.created}
							category={metadata.category}
						/>
						<div className='post-details'>
							<div className='container-row'>
								<div className='group group-left article-time'>
								</div>
								<TagBar tags={metadata.tags} />
								<ReactMarkdown
									source={post}
									renderers={{
										image: ArticleImage
									}}
									/>
							</div>
						</div>
					</article>
					<RecentPosts posts={this.props.posts} current_title={metadata.title} />
				</main>
			</div>
		)
	}
}

class RecentPosts extends Component {
	render() {
		var recent_posts = []
		recent_posts = this.props.posts.slice(0,3)
		.filter(p => p.title != this.props.current_title)
		.map(p => <Post {...p} />)

		if (recent_posts.length)
			return (
				<div className="posts-recent">
					<h3>Recent Posts</h3>
					{ recent_posts }
				</div>
			)
		return null
	}
}
class ArticleImage extends Component {
	constructor() {
		super();
		this.state = {
			expanded: false
		}
		this.handleClick = this.handleClick.bind(this);
	}
	handleClick() {
		this.setState({expanded: !this.state.expanded});
	}
	render() {
		const { expanded } = this.state;
		var image_path = this.props.src;
		if (!this.props.src.includes("://"))
			image_path = `/articles/${window.location.pathname.split('/')[2]}/${this.props.src}`;

		return (
			<span
				onClick={this.handleClick}
				className={"image-wrapper " + (expanded ? "expanded" : "")}>
				<img
				    { ...this.props }
					src={image_path}
				/>
			</span>
		)
	}
}

export const ArticlePage = withArticleMetaData(Article)



// WEBPACK FOOTER //
// ./src/Article.js